module.exports = __webpack_public_path__ + "img/drag.63f582a0.svg";